import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { CircularProgress, Box } from "@mui/material";
import { useAppDispatch } from "../../store/hooks";
import { setTokens } from "../../features/user/user.slice";
import { getUserThunk } from "../../features/user/user.thunk";

function TokenLogin() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  useEffect(() => {
    const token = searchParams.get("token");
    const refreshToken = searchParams.get("refreshToken");
    const redirect = searchParams.get("redirect") ?? "/account/billing";

    if (!token) {
      navigate("/login", { replace: true });
      return;
    }

    dispatch(setTokens({ accessToken: token, refreshToken }));
    dispatch(getUserThunk())
      .unwrap()
      .then(() => navigate(redirect, { replace: true }))
      .catch(() => navigate("/login", { replace: true }));
  }, []);

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
    >
      <CircularProgress />
    </Box>
  );
}

export default TokenLogin;
